<template>
    <ns-modal
        v-model="dialog"
        :title="txc.add_bank_account"
        :fullscreen="fullScreen"
        @input="closeDialog"
    >
        <server-error v-if="!!dialogError" :error="dialogError" />

        <v-form v-model="addBankAccountForm" @submit.prevent>
            <p class="mb-3">{{txc.direct_deposit_explanation}}</p>

            <div data-test-id="directDepositNameAcct" class="field-label">{{txc.direct_deposit_name_acct}}</div>
            <v-text-field data-test-id="name" v-model="name" readonly disabled />

            <div data-test-id="accountNumber" class="field-label">{{txc.account_number}}</div>
            <v-text-field data-test-id="accountNumber" v-model="accountNumber" required pattern="[0-9]*" :mask="mask" />

            <div data-test-id="routingNumber" class="field-label">{{txc.routing_number}}</div>
            <v-text-field data-test-id="routingNumber" v-model="routingNumber" required pattern="[0-9]*" mask="######" />

            <v-checkbox required :rules="[ruleSet.required]" class="mt-2">
                <template v-slot:label>
                    <span data-test-id="agreeToTerms" class="terms-text" v-html="ddAgreementTerms.terms_text"></span>
                </template>
            </v-checkbox>
        </v-form>
        <template v-slot:actions>
            <v-layout column>
                <v-flex xs12>
                    <button
                        flat
                        block
                        class="primary-hit mb-2 fluid"
                        :disabled="!addBankAccountForm || accountNumber.length < 9 || routingNumber.length < 6"
                        @click="submitBankInfo"
                        data-test-id="save"
                    >{{txcg.save}}</button>
                </v-flex>
                <v-spacer />
                <v-flex xs12>
                    <button
                        flat
                        outline
                        block
                        class="secondary-hit fluid"
                        @click="closeDialog"
                        data-test-id="cancel"
                    >{{txcg.cancel}}</button>
                </v-flex>
            </v-layout>
        </template>
    </ns-modal>
</template>

<script>
import * as ruleSet from '../../repositories/globalRules.js'
import profileUtils from '../../repositories/profileUtils.js'

import {
    ProfileService
} from '@nuskin/ns-account'
import {
    mapActions,
    mapGetters
} from 'vuex'

import {
    NsModal
} from '@nuskin/design-components'
import ServerError from '../ServerError'

export default {
    components: {
        NsModal,
        ServerError
    },
    data() {
        return {
            ruleSet,
            dialog: true,
            dialogError: null,
            addBankAccountForm: false,
            name: '',
            routingNumber: '',
            accountNumber: '',
            rules: {
                required: ruleSet.required
            }
        }
    },
    computed: {
        ...mapGetters({
            txc: 'translationsDirectDeposit',
            txcg: 'translationsGlobal',
            txce: 'translationsError',
            fullScreen: 'mobileView',
            localName: 'localName',
            account: 'account',
            country: 'country',
            ddAgreementTerms: 'directDepositAgreementTerms'
        }),
        mask (){
            return this.txc.directDepositIbanMask;
        }
    },
    methods: {
        ...mapActions(['setAccount']),
        closeDialog() {
            this.$emit('closeDialog');
            this.dialogError = null
        },
        submitBankInfo() {
            let ddInfo = {
                    bankAccounts: []
                },
                bankData = {
                    'accountHolder': this.name,
                    'accountNumber': this.accountNumber,
                    'routingNumber': this.routingNumber,
                    'accountPurpose': 'DIRECT_DEPOSIT',
                    'acceptedDirectDepositPolicy': true,
                    'country': this.country,
                    'action': 'ADD'
                };

            ddInfo.bankAccounts.push(bankData);
            ProfileService.updateAccountInfo(ddInfo).then((response) => {
                if(response && response.data && response.data.account && response.data.messages.length === 0) {
                    this.setAccount(response.data.account);
                    this.$emit('bankAccountAdded');
                    profileUtils.publishAnalytics(
                        this.$analytics.category.deposits,
                        'ZA_bank_account',
                        'added', {
                            email: this.account.email
                        }
                    )
                } else if(response && response.data && response.data.messages.length > 0) {
                    let error = response.data.messages[0].message;
                    throw new Error(error);
                } else {
                    throw new Error(this.txce.nonSpecific);
                }
            }).catch(error => {
                this.dialogError = error;
            });
        }
    },
    created() {
        this.name = this.localName;
        profileUtils.publishAnalytics(
            this.$analytics.category.deposits,
            'ZA_bank_account_dialog',
            'opened'
        )
    },
    destroyed() {
        profileUtils.publishAnalytics(
            this.$analytics.category.deposits,
            'ZA_bank_account_dialog',
            'closed'
        )
    }
}
</script>
<style scoped lang="scss">
    @use "sass:map";
    @use "~@nuskin/ns-core-styles/src/scss/global.mixins";
    .terms-text {
       @include global.paragraph-m();
    }
</style>
